/**
 * Profile definitions for sample memory generation
 */

import { designerProfile } from './profiles.designer';
import { developerProfile } from './profiles.developer';
import { managerProfile } from './profiles.manager';
import { officeProfile } from './profiles.office';
import { pwcProfile } from './profiles.pwc';
import { seeingMachinesProfile } from './profiles.seeing-machines';
import type { DemoMemoryPreset } from './types';

export interface Profile {
  name: string;
  minMeetingsPerDay: number;
  sessions: Array<ProfileSession>;
  meetings: Array<ProfileCalendarSession>;
  averageSwitchingFrequencySeconds: number;
}

export interface ProfileSession {
  name: string;
  /// Default: 45
  maxLengthMinutes?: number;
  entries: Array<ProfileSessionEntry>;
  predominantTool: string;
  aiNotes: {
    concise: string;
    detailed: string;
  };
}

export interface ProfileSessionEntry {
  /// If not set, use URL to build tool id
  tool?: string;
  url?: string;
  title: string;
}

export interface ProfileCalendarSession {
  title: string;
  durationMinutes: number;
  entries: Array<ProfileSessionEntry>;
  aiNotes: {
    concise: string;
    detailed: string;
  };
}

export const profiles: Record<DemoMemoryPreset, Profile> = {
  developer: developerProfile,
  designer: designerProfile,
  manager: managerProfile,
  office: officeProfile,
  seeing_machines: seeingMachinesProfile,
  pwc: pwcProfile,
};
